import {Component} from '@angular/core';

@Component({
    template: `<div class="alert alert-danger"><p>No teniu permisos per accedir a aquesta pàgina.</p></div>`,
})

export class NoPermissionComponent {
}
